<template>
  <div>
    <div class="col-12 p-2 d-flex align-items-center mt-4">
      <div class="w-100 pt-0 ">
        <div class="title-divider" />
      </div>
      <div class="col-auto title-content py-1 text-center mx-3">
        <div>
          <span>{{ resultsDividerLabel }}</span>
        </div>
      </div>
      <div class="w-100 pt-0 ">
        <div class="title-divider w-100" />
      </div>
    </div>

    <div
      v-if="results.length === 0"
      class="col-12 p-4 text-center align-items-center no-info mt-4"
    >
      <div class="row justify-content-center">
        <div class="col-12 col-lg-1 align-self-center">
          <i class="far fa-folder-open icon no-info-icon pl-2" />
        </div>
        <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
          <span class="no-info-text">No hay información disponible.</span>
        </div>
      </div>
    </div>

    <div v-if="results.length !== 0">
      <div class="mb-4" v-for="(item, id) in results" :key="id">
        <custom-callout
          :controlled="true"
          :has-toggle="showHistory(item.submittedDocumentDeterminationStatusId)"
          :opened="item.isOpen"
          @click:open="show(item)"
          :border-color="
            getBorderStatusClass(item.submittedDocumentDeterminationStatusId)
          "
        >
          <div>
            <div class="row">
              <div
                class="col-md-2 col-sm-12 mt-0 mt-md-2 mt-sm-0 border-right "
              >
                <span
                  :class="
                    'text-center px-4 my-0 my-md-5 my-sm-0 badge ml-5 ' +
                      getStatusClass(
                        item.submittedDocumentDeterminationStatusId
                      )
                  "
                >
                  {{ item.submittedDocumentDeterminationStatus }}
                </span>
              </div>
              <div class="col-md-8 col-sm-12 pt-2 pl-3">
                <div class="row pl-4">
                  <div class="col-md-4 col-sm-12 pt-2">
                    <span class="data-title">
                      Región:
                      <br />
                    </span>
                    <span class="data-content">{{ item.regionName }}</span>
                  </div>
                  <div class="col-md-4 col-sm-12 pt-2">
                    <span class="data-title">
                      Distrito:
                      <br />
                    </span>
                    <span class="data-content">{{ item.districtName }}</span>
                  </div>
                  <div class="col-md-4 col-sm-12 pt-2">
                    <span class="data-title">
                      Escuela:
                      <br />
                    </span>
                    <span class="data-content">
                      {{ item.sieSchoolId }} - {{ item.schoolName }}
                    </span>
                  </div>
                </div>
                <div class="row pl-4">
                  <div class="col-md-4 col-sm-12 pt-2">
                    <span class="data-title">
                      Estipulación:
                      <br />
                    </span>
                    <span class="data-content">{{
                      item.courtStipulations
                    }}</span>
                  </div>
                  <div class="col-md-8 col-sm-12 pt-2">
                    <span class="data-title">
                      Tipo de Documento:
                      <br />
                    </span>
                    <span class="data-content">
                      {{ item.submittedDocumentTypeName }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="
                    isApprovedOrDenied(
                      item.submittedDocumentDeterminationStatusId
                    )
                  "
                  class="row pl-4"
                ></div>
              </div>
              <div class="col-md-2 col-sm-12 pt-2">
                <DropDown
                  :key="item.submittedDocumentId"
                  ref="actionContentOption"
                  class="d-flex justify-content-end mt-5 pr-2"
                  :items="getActionItems(item)"
                  @downloadEvidence="downloadReport(item)"
                  @approveItem="approveItem(item)"
                  @revertItemPanel="openPanel(item, 'revert')"
                  @openRejectPanel="openPanel(item, 'reject')"
                  @openSubmitPanel="openSubmitPanel(item)"
                  @goToHistory="goToHistory(item)"
                />
              </div>
            </div>
          </div>

          <RLVEvidenceActionContent
            v-if="item.rejectPanel || item.revertPanel"
            slot="edition"
            :item="item"
            @rejectEvidence="rejectEvidence(item, $event)"
            @revertItem="revertItem(item, $event)"
            @cancelEvidence="cancelEvidence(item)"
          />

          <AttachDocument
            v-if="item.submitPanel"
            slot="edition"
            :item="item"
            @acceptUploadDocumment="acceptUploadDocumment(item)"
            @cancelSubmitPanelEvidence="cancelSubmitPanelEvidence(item)"
          />
        </custom-callout>
        <div
          class="aditional-container round-container p-2"
          v-if="
            item.isOpen &&
              !(item.rejectPanel || item.revertPanel || item.submitPanel)
          "
        >
          <div class="bg-white round-container">
            <CustomTab
              content-class="mt-3"
              :no-nav-style="true"
              class="custom-tab-font"
              nav-class="nav-vue-underline"
              :model="tabIndex"
            >
              <CustomTabItem
                v-if="showHistory(item.submittedDocumentDeterminationStatusId)"
                class="mt-2"
                :active="tabIndex === 1"
                title="Historial"
              >
                <RlvHistory :documentInfo="item" />
              </CustomTabItem>
              <CustomTabItem
                class="mt-2"
                v-if="
                  showDetermination(item.submittedDocumentDeterminationStatusId)
                "
                :active="tabIndex === 2"
                title="Determinación"
              >
                <div class="ml-3">
                  <RlvDetermination :data="item" />
                </div>
              </CustomTabItem>
            </CustomTab>
          </div>
        </div>
      </div>
      <Pagination
        id="pgRLVEvidenceResult"
        :show-text="true"
        :data="pagination"
        @pagination-go-page="goToPage"
      />
    </div>
  </div>
</template>

<script>
import generalService from "@/services/pei/general";
import Pagination from "@/components/common/Pagination.vue";
import submittedDocumentDeterminationStatus from "@/utils/constants/student/submittedDocumentDeterminationStatus";
import RLVEvidenceActionContent from "@/views/student/RLVEvidences/components/RLVEvidenceActionContent.vue";
import RlvAditionalInformation from "@/views/student/RLVEvidences/components/RVLAditionalinformation.vue";
import RlvDetermination from "@/views/student/RLVEvidences/components/RVLDetermination.vue"; //
import RlvHistory from "@/views/student/RLVEvidences/components/RLVHistory.vue";
import AttachDocument from "@/views/student/RLVEvidences/components/RLVSubmitDocument.vue";
import DropDown from "@/components/common/menu/DropDown";
import CustomAlert from "@/mixin/alert.mixin";
import CustomCallout from "custom-callout";
import mixAlert from "@/mixin/alert.mixin";
import userRole from "@/utils/constants/userRoles";
import moment from "moment";
import { CustomTab, CustomTabItem } from "custom-tabs";
const tabsInfo = {
  aditionalInformation: 0,
  history: 1,
  determination: 2
};
export default {
  name: "RLVEvidenceResults",
  mixins: [mixAlert],
  props: {
    resultsDividerLabel: {
      type: String,
      default: "Resultados"
    },
    results: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalItemCount: {
      type: Number,
      default: 0
    },
    pageCount: {
      type: Number,
      default: 1
    },
    count: {
      type: Number,
      default: 0
    },
    refreshPage: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      pagination: {
        currentPage: this.currentPage,
        totalItemCount: this.totalItemCount,
        pageCount: this.pageCount,
        count: this.count
      },
      pageSize: 10,
      showDetails: false,
      tabIndex: 0
    };
  },
  computed: {
    hasReturnToSubmittedPermission() {
      return this.$store.getters.HasPermission(
        "student.reportsrosalydiavelez.returntosubmitted"
      );
    }
  },
  components: {
    Pagination,
    DropDown,
    RLVEvidenceActionContent,
    RlvDetermination,
    RlvHistory,
    CustomCallout,
    AttachDocument,
    CustomTab,
    CustomTabItem,
    RlvAditionalInformation
  },
  methods: {
    getActionItems(item) {
      let items = [
        {
          Title: `Descargar Evidencia`,
          Icon: "fas fa-download",
          IconColor: "text-green",
          Type: "Menu",
          EmitGo: "downloadEvidence",
          Children: [],
          Visible: this.checkIfDownloadEvidence(
            item.submittedDocumentDeterminationStatusId
          ),
          HasLine:
            this.isSubmitted(item.submittedDocumentDeterminationStatusId) &&
            item.showDeterminationButton &&
            this.hasConfirmPermission()
        },
        {
          Title: "Aprobar",
          Icon: "fas fa-check-square",
          IconColor: "text-green",
          Type: "Menu",
          EmitGo: "approveItem",
          Children: [],
          Visible:
            this.isSubmitted(item.submittedDocumentDeterminationStatusId) &&
            item.showDeterminationButton &&
            this.hasConfirmPermission()
        },
        {
          Title: "Denegar",
          Icon: "fas fa-times-square",
          IconColor: "text-red",
          Type: "Menu",
          EmitGo: "openRejectPanel",
          Children: [],
          Visible:
            this.isSubmitted(item.submittedDocumentDeterminationStatusId) &&
            item.showDeterminationButton &&
            this.hasDenyPermission()
        },
        {
          Title: "Regresar Determinación a Sometido",
          Icon: "fas fa-repeat",
          IconColor: "text-green",
          Type: "Menu",
          EmitGo: "revertItemPanel",
          Children: [],
          Visible:
            this.isApprovedOrDenied(
              item.submittedDocumentDeterminationStatusId
            ) &&
            this.hasReturnToSubmittedPermission
        },
        {
          Title: "Subir Documento",
          Icon: "fas fa-plus-circle",
          IconColor: "text-green",
          Type: "Menu",
          EmitGo: "openSubmitPanel",
          Children: [],
          Visible:
            (submittedDocumentDeterminationStatus.NoSometido ==
              item.submittedDocumentDeterminationStatusId ||
              submittedDocumentDeterminationStatus.Denegado ==
                item.submittedDocumentDeterminationStatusId) &&
            this.hasUploadDocumentPermission()
        },
        {
          Title: "Historial",
          Icon: "fas fa-history",
          IconColor: "text-green",
          Type: "Menu",
          EmitGo: "goToHistory",
          Children: [],
          Visible:
            submittedDocumentDeterminationStatus.NoSometido !=
            item.submittedDocumentDeterminationStatusId
        }
      ];

      return items;
    },
    show(i) {
      if (!i.isOpen) {
        this.openPanel(i, "details");
      } else {
        this.cancelSubmitPanelEvidence(i);
      }
    },
    hasConfirmPermission() {
      return this.$store.getters.HasPermission(
        "student.reportsrosalydiavelez.approve"
      );
    },
    hasDenyPermission() {
      return this.$store.getters.HasPermission(
        "student.reportsrosalydiavelez.deny"
      );
    },
    hasUploadDocumentPermission() {
      return this.$store.getters.HasPermission(
        "student.reportsrosalydiavelez.uploaddocument"
      );
    },
    checkIfDownloadEvidence(status) {
      return (
        status === submittedDocumentDeterminationStatus.Sometido ||
        status === submittedDocumentDeterminationStatus.Aprobado ||
        status === submittedDocumentDeterminationStatus.Denegado
      );
    },
    isSubmitted(status) {
      return status === submittedDocumentDeterminationStatus.Sometido;
    },
    showDetermination(status) {
      return status === submittedDocumentDeterminationStatus.Denegado;
    },
    showHistory(status) {
      return status !== submittedDocumentDeterminationStatus.NoSometido;
    },
    isApprovedOrDenied(status) {
      return [
        submittedDocumentDeterminationStatus.Aprobado,
        submittedDocumentDeterminationStatus.Denegado
      ].includes(status);
    },
    acceptUploadDocumment(item) {
      item.submittedDocumentDeterminationStatus = "Sometido";
      item.submittedDocumentDeterminationStatusId =
        submittedDocumentDeterminationStatus.Sometido;
      item.isOpen = false;
      item.submitPanel = false;
      this.$forceUpdate();

      this.$emit("refresh-search");

      this.ShowToast(
        "Proceso Existoso",
        "Se ha subido el documento exitosamente.",
        "success"
      );
    },
    rejectEvidence(item, input) {
      let data = {
        statusId: submittedDocumentDeterminationStatus.Denegado,
        comments: input.comments,
        denegationReasonId: input.denegationReasonId
      };

      this.$ApiPost(
        `api/rlvEvidence/updatestatus/${item.submittedDocumentId}`,
        data
      )
        .then(() => {
          item.submittedDocumentDeterminationStatus = "Denegado";
          item.submittedDocumentDeterminationStatusId =
            submittedDocumentDeterminationStatus.Denegado;
          item.isOpen = false;
          item.rejectPanel = false;
          this.$forceUpdate();

          this.$emit("refresh-search");

          this.ShowToast(
            "Proceso Existoso",
            "La evidencia fue denegada exitosamente.",
            "success"
          );
        })
        .catch(err => {
          this.ShowToast(err.message, "", "error");
        });
    },
    cancelEvidence(item) {
      item.isOpen = false;
      item.rejectPanel = false;
      item.revertPanel = false;
      this.$forceUpdate();
    },
    cancelSubmitPanelEvidence(item) {
      item.isOpen = false;
      item.submitPanel = false;
      this.$forceUpdate();
    },
    async approveItem(item) {
      let alertResponse = await CustomAlert.methods.ShowCancelModal(
        "Aviso",
        "¿Desea aprobar la evidencia?",
        "Sí",
        "No"
      );

      if (alertResponse) {
        let data = {
          statusId: submittedDocumentDeterminationStatus.Aprobado,
          comments: ""
        };

        this.$ApiPost(
          `api/rlvEvidence/updatestatus/${item.submittedDocumentId}`,
          data
        )

          .then(() => {
            item.submittedDocumentDeterminationStatus = "Aprobado";
            item.submittedDocumentDeterminationStatusId =
              submittedDocumentDeterminationStatus.Aprobado;
            this.$forceUpdate();

            this.$emit("refresh-search");

            this.ShowToast(
              "Proceso Existoso",
              "La evidencia ha sido aprobada exitosamente.",
              "success"
            );
          })
          .catch(err => {
            this.ShowToast(err.message, "", "error");
          });
      }
    },
    async revertItem(item, comment) {
      this.$ApiPost(
        `api/rlvEvidence/revertstatus/${item.submittedDocumentId}`,
        { comments: comment }
      )
        .then(() => {
          item.submittedDocumentDeterminationStatus = "Sometido";
          item.submittedDocumentDeterminationStatusId =
            submittedDocumentDeterminationStatus.Sometido;
          this.$forceUpdate();
          this.$emit("refresh-search");
          this.ShowToast(
            "Proceso Existoso",
            "El estatus de la evidencia ha sido modificado exitosamente.",
            "success"
          );
        })
        .catch(err => {
          this.ShowToast(err.message, "", "error");
        });
    },

    openPanel(item, status) {
      this.cancelSubmitPanelEvidence(item);

      this.showRejectComment = true;
      item.isOpen = true;
      if (status == "details") {
        item.isOpen = true;
        item.revertPanel = false;
      } else if (status == "reject") {
        item.rejectPanel = true;
        item.revertPanel = false;
      } else {
        item.rejectPanel = false;
        item.revertPanel = true;
      }

      this.$forceUpdate();
    },
    openSubmitPanel(item) {
      this.cancelEvidence(item);
      item.submitPanel = true;
      item.isOpen = true;
      this.$forceUpdate();
    },
    goToHistory(item) {
      this.show(item);
      this.tabIndex = tabsInfo.history;
    },
    goToPage(page) {
      this.pagination.currentPage = page;
      this.$emit("pagination-go-page", page);
    },
    downloadReport(item) {
      let self = this;
      let promise = new Promise(resolve => {
        self
          .$ApiGet(
            `/api/rlvevidence/evidenceReport/${item.submittedDocumentId}`
          )
          .then(res => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch(err => {
            self.response = err;
          });
      });
      return promise;
    },
    getStatusClass(status) {
      let statusClass = "";
      switch (status) {
        case submittedDocumentDeterminationStatus.NoSometido:
          statusClass = "no-completed ml-6";
          break;
        case submittedDocumentDeterminationStatus.Sometido:
          statusClass = "completed";
          break;
        case submittedDocumentDeterminationStatus.Aprobado:
          statusClass = "approved";
          break;
        case submittedDocumentDeterminationStatus.Denegado:
          statusClass = "denied";
          break;
      }

      return statusClass;
    },
    getBorderStatusClass(status) {
      let statusClass = "";
      switch (status) {
        case submittedDocumentDeterminationStatus.NoSometido:
          statusClass = "pink";
          break;
        case submittedDocumentDeterminationStatus.Sometido:
          statusClass = "yellow";
          break;
        case submittedDocumentDeterminationStatus.Aprobado:
          statusClass = "green";
          break;
        case submittedDocumentDeterminationStatus.Denegado:
          statusClass = "brown";
          break;
      }

      return statusClass;
    },
    isDenied(submittedDocumentDeterminationStatusId) {
      return (
        submittedDocumentDeterminationStatusId ==
        submittedDocumentDeterminationStatus.Denegado
      );
    },
    isApproved(submittedDocumentDeterminationStatusId) {
      return (
        submittedDocumentDeterminationStatusId ==
        submittedDocumentDeterminationStatus.Aprobado
      );
    },
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale("es")
          .format("DD/MMM/YYYY");
      }

      return "";
    }
  },
  watch: {
    refreshPage() {
      if (this.refreshPage) {
        this.pagination.pageCount = this.pageCount;
        this.pagination.count = this.count;
        this.pagination.totalItemCount = this.totalItemCount;
        this.pagination.currentPage = 1;
      }
    }
  }
};
</script>

<style scoped>
.border__left--no-interview {
  border-left: 3px solid #f8eb7f !important;
}

.border__left--completed {
  border-left: 3px solid #f8ea7f !important;
}

.border__left--in-process {
  border-left: 3px solid #d5b89a !important;
}
.border__left--no-completed {
  border-left: 3px solid #deb3d7 !important;
}

.border__left--denied {
  border-left: 3px solid #d5b899 !important;
}

.border__left--approved {
  border-left: 3px solid #a3e5b3 !important;
}

.badge.no-completed {
  height: 32px;
  background: #fcc9c8 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.denied {
  height: 32px;
  background: #d5b899 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.approved {
  height: 32px;
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.completed {
  height: 32px;
  background: #f8ea7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.btn-setting {
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0px !important;
  color: #ffffff;
  opacity: 1;
}
.btn-setting-off {
  background-color: #f4f6f3;
  border-radius: 4px;
  border: 0px !important;
  color: #3f5b60;
}

.search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.title-divider {
  border: 1px solid #b5c3bc;

  opacity: 1;
}
.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.filter-content {
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #aab7b1;
  opacity: 1;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.interview-status {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.egress-interview {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;

  border-left-style: solid;
  border-color: #f8eb7f;
  border-width: 4px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.dropdown-action-divider {
  border-top-width: 1px;
  border-top-style: solid;
  border-color: #e2e2e2;
  margin-left: 5%;
  margin-right: 5%;
}

.settings-button {
  align-content: center;

  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 8px;
  padding-right: 4px;
  color: #e2e2e2;
}

.aditional-container {
  background-color: #f7f7f7;
}
.round-container {
  border-radius: 5px;
}

.custom-tab-font {
  --tab-font-size: 16px !important;
}
.ml-6 {
  margin-left: 62px !important;
}
</style>
